import { IVariable } from "../../interfaces/IVariable";
import { createTheme, Theme } from "@mui/material/styles";
import { darkenColor } from "../../util/helpers";
import { getlocalStorageIdHotsite } from "../../util/LocalStorage";

let idHotsiteLocalStorage = getlocalStorageIdHotsite();

export const variables: IVariable = {
  IdHotsite:idHotsiteLocalStorage > 0 ? idHotsiteLocalStorage :  14,
  Loja: "Infinity Câmbio",
  UserStorage: "7S8GXNhvh0i39kx1L1Ezhw==",
  UserToken: "ezcspcYRJkuWbf51MXmUdA==",
  UrlApi: "https://prd-ecommerce-duo-api.primecase.com.br/api",
  UrlLoja:"https://prd-inf-ljc-web.primecase.com.br/",
  UrlServiceHost: "https://dev2-pri-sgc-api.primecase.com.br/",

  OrgId: "",
  ProviderMerchantId: ""
};

export const template: Theme = createTheme({
  palette: {
    primary: {
      main: "#008363",
      light: "#008363",
      //lighter: "#ece6f7",
      dark: darkenColor("#008363", 10), // Escurece em 20%
    },
    secondary: {
      main: "#292d2f",
    },
    error: {
      main: "#a91c1c",
    },
    text: {
      primary: "#222",
      //light: "#fff",
    },
    warning: {
      main: "#ff9800",
    },
    // white: {
    //   main: "#fff",
    // },
  },

  typography: {
    subtitle1: {
      fontSize: 12,
    },
    body1: {
      fontSize: 14,
    },
  },
});
